import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { UserRole } from "../models/enums/UserRoleEnum";
import { useRegister } from "../services/api/services";
import LoadingPanel from "../components/LoadingPanel";
import { useNavigate } from "react-router-dom";
function Signup() {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [registerState, register] = useRegister();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    workStartDay: "",
    workEndDay: "",
    workingStartHour: "",
    workingEndHour: "",
    password: "",
    confirmPassword: "",
    dob: "",
  });

  useEffect(() => {
    if (registerState.data?.status === 0) {
      navigate("/login");
    }
  }, [registerState.data]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleNext = (e: React.FormEvent) => {
    e.preventDefault();
    setStep(2);
  };

  const handleSignup = (e: React.FormEvent) => {
    e.preventDefault();
    if (formData.password !== formData.confirmPassword) {
      alert("Passwords do not match!");
      return;
    }
    register({
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      phone: formData.phone,
      workStartDay: formData.workStartDay,
      workEndDay: formData.workEndDay,
      workingStartHour: formData.workingStartHour,
      workingEndHour: formData.workingEndHour,
      password: formData.password,
      dob: formData.dob,
      roleId: UserRole.Patient,
      orgId: 1,
      doctorId: 1,
    });
  };

  return (
    <>
      {registerState?.loading && (
        <LoadingPanel fullScreen message="Signing Up..." />
      )}
      <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
        <div className="card shadow p-4" style={{ width: "400px" }}>
          <h2 className="text-center mb-4">Sign Up</h2>
          <form onSubmit={step === 1 ? handleNext : handleSignup}>
            {step === 1 && (
              <>
                <div className="mb-3">
                  <label htmlFor="firstName" className="form-label">
                    First Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="firstName"
                    name="firstName"
                    placeholder="Enter your first name"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="lastName" className="form-label">
                    Last Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="lastName"
                    name="lastName"
                    placeholder="Enter your last name"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    Email Address
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    placeholder="Enter your email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="phone" className="form-label">
                    Phone
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="phone"
                    name="phone"
                    placeholder="Enter your phone number"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                </div>

                <button type="submit" className="btn btn-primary w-100">
                  Next
                </button>
              </>
            )}

            {step === 2 && (
              <>
                <div className="mb-3">
                  <label htmlFor="dob" className="form-label">
                    Date of Birth
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id="dob"
                    name="dob"
                    value={formData.dob}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="password" className="form-label">
                    Password
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    name="password"
                    placeholder="Enter your password"
                    value={formData.password}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="mb-3">
                  <label htmlFor="confirmPassword" className="form-label">
                    Confirm Password
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="confirmPassword"
                    name="confirmPassword"
                    placeholder="Confirm your password"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                    required
                  />
                </div>

                <button type="submit" className="btn btn-success w-100">
                  Sign Up
                </button>

                <button
                  type="button"
                  className="btn btn-link w-100 mt-2"
                  onClick={() => setStep(1)}
                >
                  Back
                </button>
              </>
            )}
          </form>
        </div>
      </div>
    </>
  );
}

export default Signup;
